<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/ticket")
          i.fas.fa-list-alt
          span.ml-1 {{ $t("ui.ticket_list") }}
  b-card(body-class="").p-0
    div(slot="header")
      div.row.col-md-12.mb-1
        div(width="30%").mr-3
          DateRangePicker(:value="dateRange" @update="getData")
        div(width="20%").mr-3
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-user
            DebounceInput(type="text" v-model="search" :placeholder="$t('message.search_by_id')")
        div(width="20%").mr-3
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              span {{ $t('ui.status') }}
            b-form-select(v-model="ticketStatus" @change="getTicketList")
              option(value="") {{ $t('ui.all') }}
              option(value="REJECTED") {{ $t('ui.rejected') }}
              option(value="PENDING") {{ $t('ui.pending') }}
              option(value="PROCESSED") {{ $t("ui.processed") }}
        div(width="20%").mr-3
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              span {{ $tc('ui.banks', 1) }}
            b-form-select(v-model="bankId" @change="getTicketList")
              option(value="") {{ $t('ui.all') }}
              option(v-for="option in bankOptions" :value="option.bank_id") {{ option.bank_name }}
            //- BankLookup(
            //-   ref="bankId"
            //-   size="sm"
            //-   type="array"
            //-   v-model="bankId"
            //-   @input="getTicketList"
            //- )
        div(width="10%")
          SubmitButton(
            ref="search_btn"
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getTicketList()"
            variant="success"
            size="sm"
            ).mr-3
          jsonToExcel(v-if="depositList.length > 0" mode="DepositList" tbl="tblDep" :date="dateRange" btnTxt="export_deposit").mr-3
          jsonToExcel(v-if="withdrawalList.length > 0" mode="WithdrawalList" tbl="tblWdw" :date="dateRange" btnTxt="export_withdrawal")
    b-tabs(small card)
      b-tab(title-link-class="small-link" title-item-class="small-item")
        template(slot="title")
          span(style="padding: 1px; line-height: 16px;") {{ $t("ui.deposit") }}
          b-badge(variant="danger" size="sm" style="width: 30px; vertical-align: top;").ml-1 {{ depTotalRow }}
        div.d-flex.flex-wrap
          div.clusterize
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="depTotalRow"
                  :per-page="getPageSize"
                  v-model="currentDepPage"
                  @input="changedDepPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.utmPageSizeOptions" :value="getPageSize" @input="changedDepPageSize")
            .clusterize-scroll
              table.tablex#tblDep(style="width: 100%")
                thead
                  tr
                    th.sticky-position(width="3%")
                      span #
                    th.sticky-position.sortable(width="5%")
                      span(:title="$t('ui.id')") {{ $t('ui.id') }}
                    th.sticky-position.sortable(width="8%" @click="sortOrder('member_id', 'dep')")
                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                      i(:class="changeSortKey('member_id', 'dep')")
                    th.sticky-position.sortable(width="5%" @click="sortOrder('target_bank_id', 'dep')")
                      span(:title="$tc('ui.banks', 1)") {{ $tc('ui.banks', 1) }}
                      i(:class="changeSortKey('target_bank_id', 'dep')")
                    th.sticky-position.sortable(width="8%" @click="sortOrder('target_bank_acc_no', 'dep')")
                      span(:title="$t('ui.bank_acc_no')") {{ $t('ui.bank_acc_no') }}
                      i(:class="changeSortKey('target_bank_acc_no', 'dep')")
                    th.sticky-position(width="8%")
                      span(:title="$t('ui.bank_acc_holder')") {{ $t('ui.bank_acc_holder') }}
                    th.sticky-position(width="8%" @click="sortOrder('amount', 'dep')")
                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                      i(:class="changeSortKey('amount', 'dep')")
                    th.sticky-position.sortable(width="6%" @click="sortOrder('promotion_id', 'dep')")
                      span(:title="$t('ui.promo')") {{ $t("ui.promo") }}
                      i(:class="changeSortKey('promotion_id', 'dep')")
                    th.sticky-position.sortable(width="6%" @click="sortOrder('bonus_amount', 'dep')")
                      span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                      i(:class="changeSortKey('bonus_amount', 'dep')")
                    th.sticky-position.sortable(width="8%" @click="sortOrder('status', 'dep')")
                      span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      i(:class="changeSortKey('status', 'dep')")
                    th.sticky-position(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                      span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                    th.sticky-position(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'" width="10%")
                      span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
                    th.text-right.sticky-position(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'" width="10%")
                      span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                    th.text-right.sticky-position.sortable(width="10%" @click="sortOrder('created_date', 'dep')")
                      span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                      i(:class="changeSortKey('created_date', 'dep')")
                tbody.clusterize-content
                  tr(v-if="depositList.length == 0")
                    td(:colspan="ticketStatus.trim().toUpperCase() != 'PENDING' ? '14' : '11'").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in depositList" :class="$helpers.rowClassTicket(item)")
                    td
                      span(:title="((currentDepPage - 1) * getPageSize + index + 1)") {{ ((currentDepPage - 1) * getPageSize + index + 1) }}
                    td
                      span(:title="item.id") {{ item.id }}&nbsp;
                    td
                      span(:title="item.member_id") {{ item.member_id }}&nbsp;
                    td
                      span(:title="item.target_bank_id") {{ item.target_bank_id }}&nbsp;
                    td
                      span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}&nbsp;
                    td
                      span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}&nbsp;
                    td
                      span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                    td
                      span(:title="item.promotion_id") {{ item.promotion_id }}&nbsp;
                    td
                      span(:title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                    td
                      span.font-weight-bold.text-info(v-if="item.status.trim().toUpperCase() == 'PENDING'") {{ item.status.trim().toUpperCase() }}&nbsp;
                      span.font-weight-bold.text-success(v-if="item.status.trim().toUpperCase() == 'PROCESSED'") {{ item.status.trim().toUpperCase() }}&nbsp;
                      span.font-weight-bold.text-danger(v-if="item.status.trim().toUpperCase() == 'REJECTED'") {{ item.status.trim().toUpperCase() }}&nbsp;
                    td(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                      span(:title="item.remark") {{ item.remark }}&nbsp;
                    td(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                      span(:title="item.modified_by") {{ item.modified_by }}&nbsp;
                    td.text-right(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                      span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
                    td.text-right
                      span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
      b-tab(title-link-class="small-link" title-item-class="small-item")
        template(slot="title")
          span(style="padding: 1px; line-height: 16px;") {{ $t("ui.withdrawal") }}
          b-badge(variant="danger" size="sm" style="width: 30px; vertical-align: top;").ml-1 {{ wdwTotalRow }}
        div.d-flex.flex-wrap
          div.clusterize
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="wdwTotalRow"
                  :per-page="getPageSize"
                  v-model="currentWdwPage"
                  @input="changedWdwPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.utmPageSizeOptions" :value="getPageSize" @input="changedWdwPageSize")
            .clusterize-scroll
              table.tablex#tblWdw(style="width: 100%;")
                thead
                  tr
                    th.sticky-position(width="3%")
                      span #
                    th.sticky-position.sortable(width="5%")
                      span(:title="$t('ui.id')") {{ $t('ui.id') }}
                    th.sticky-position.sortable(width="8%" @click="sortOrder('member_id', 'wdw')")
                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                      i(:class="changeSortKey('member_id', 'wdw')")
                    th.sticky-position.sortable(width="7%" @click="sortOrder('amount', 'wdw')")
                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                      i(:class="changeSortKey('amount', 'wdw')")
                    th.sticky-position.sortable(width="5%" @click="sortOrder('target_bank_id', 'wdw')")
                      span(:title="$tc('ui.banks', 1)") {{ $tc('ui.banks', 1) }}
                      i(:class="changeSortKey('target_bank_id', 'wdw')")
                    th.sticky-position.sortable(width="8%" @click="sortOrder('target_bank_acc_no', 'wdw')")
                      span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                      i(:class="changeSortKey('target_bank_acc_no', 'wdw')")
                    th.sticky-position.sortable(width="10%" @click="sortOrder('status', 'wdw')")
                      span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      i(:class="changeSortKey('status', 'wdw')")
                    th.sticky-position(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'" width="16%")
                      span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                    th.sticky-position(width="10%" v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                      span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
                    th.text-right.sticky-position(width="10%" v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                      span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                    th.text-right.sticky-position.sortable(width="10%" @click="sortOrder('created_date', 'wdw')")
                      span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                      i(:class="changeSortKey('created_date', 'wdw')")
                tbody.clusterize-content
                  tr(v-if="withdrawalList.length == 0")
                    td(:colspan="ticketStatus.trim().toUpperCase() != 'PENDING' ? '11' : '8'").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in withdrawalList")
                    td
                      span(:title="((currentWdwPage - 1) * getPageSize + index + 1)") {{ ((currentWdwPage - 1) * getPageSize + index + 1) }}
                    td
                      span(:title="item.id") {{ item.id }}&nbsp;
                    td
                      span(:title="item.member_id") {{ item.member_id }}&nbsp;
                    td
                      span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                    td
                      span(:title="item.target_bank_id") {{ item.target_bank_id }}&nbsp;
                    td
                      span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}&nbsp;
                    td
                      span.font-weight-bold.text-info(v-if="item.status.trim().toUpperCase() == 'PENDING'") {{ item.status.trim().toUpperCase() }}&nbsp;
                      span.font-weight-bold.text-success(v-if="item.status.trim().toUpperCase() == 'PROCESSED'") {{ item.status.trim().toUpperCase() }}&nbsp;
                      span.font-weight-bold.text-danger(v-if="item.status.trim().toUpperCase() == 'REJECTED'") {{ item.status.trim().toUpperCase() }}&nbsp;
                    td(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                      span(:title="item.remark") {{ item.remark }}&nbsp;
                    td(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                      span(:title="item.modified_by") {{ item.modified_by }}&nbsp;
                    td.text-right(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                      span(v-if="item.status.trim().toUpperCase() == 'PENDING'") {{ item.modified_date }}
                      span(v-else :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    td.text-right
                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    ticketdetail(ref="ticketdetail" :ticketId="selectedTicketId" @failed="handleFailed")
    redepositticket(ref="redepositticket" :ticketId="selectedTicketId" :memberId="selectedMemberId" @clicked="afterRedeposit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ticketdetail from "@/components/ticket/ticketDetail.vue";
import redepositticket from "@/components/ticket/redepositTicket.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ticketdetail,
    redepositticket,
    DateRangePicker,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    depositList: [],
    withdrawalList: [],
    currentDepPage: 1,
    currentWdwPage: 1,
    depTotalRow: 0,
    wdwTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    ticketStatus: "",
    requestType: null,
    selectedTicketId: null,
    selectedTicket: null,
    selectedMemberId: null,
    depSortKey: "created_date",
    depSortType: "desc",
    wdwSortKey: "created_date",
    wdwSortType: "desc",
    al: null,
    search: '',
    bankId: '',
    bankOptions: [],
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.utmPageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    // this.$refs.search_btn.$el.click();
    this.getBankLookup();
    this.getTicketList(true);
  },
  methods: {
    sortOrder(key, type) {
      if (type == 'dep') {
        if (this.depSortKey == key)
          this.depSortType = this.depSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.depSortKey = key;
          this.depSortType = 'asc';
        }

        this.getDepositList(true);
      } else if (type == 'wdw') {
        if (this.wdwSortKey == key)
          this.wdwSortType = this.wdwSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.wdwSortKey = key;
          this.wdwSortType = 'asc';
        }

        this.getWithdrawalList(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'dep') {
        if (this.depSortKey != key)
          return 'fas fa-sort';
        else if (this.depSortKey == key && this.depSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.depSortKey == key && this.depSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'wdw') {
        if (this.wdwSortKey != key)
          return 'fas fa-sort';
        else if (this.wdwSortKey == key && this.wdwSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.wdwSortKey == key && this.wdwSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    getBankLookup: function() {
      let url = config.bankLookupUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.bankOptions = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getTicketList(true);
    },
    getTicketList() {
      if (this.checkDateRange()) {
        this.getDepositList(true);
        this.getWithdrawalList(true);
      } else {
        this.depositList = [];
        this.depTotalRow = 0;
        this.withdrawalList = [];
        this.wdwTotalRow = 0;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getDepositList: function(isSearch) {
      let url = config.ticketListUrl();

      if (isSearch) this.currentDepPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ticket_status: this.ticketStatus == "" ? null : this.ticketStatus,
        request_type: 'DEPOSIT',
        bank_id: this.bankId == "" ? null : this.bankId,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        sort_key: this.depSortKey,
        sort_type: this.depSortType,
        page_number: this.currentDepPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.member_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depositList = response.data.dt;
                this.depTotalRow = this.depositList.length > 0 ? this.depositList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getWithdrawalList: function(isSearch) {
      let url = config.ticketListUrl();

      if (isSearch) this.currentWdwPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ticket_status: this.ticketStatus == "" ? null : this.ticketStatus,
        request_type: 'WITHDRAWAL',
        bank_id: this.bankId == "" ? null : this.bankId,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        sort_key: this.wdwSortKey,
        sort_type: this.wdwSortType,
        page_number: this.currentWdwPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.member_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalList = response.data.dt;
                this.wdwTotalRow = this.withdrawalList.length > 0 ? this.withdrawalList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedDepPageSize: function(pageSize) {
      this.$store.dispatch("layout/setUTMPageSize", pageSize);
      this.currentDepPage = 1;
      this.getDepositList(true);
    },
    changedDepPage: function(pageNo) {
      this.currentDepPage = pageNo;
      this.getDepositList();
    },
    changedWdwPageSize: function(pageSize) {
      this.$store.dispatch("layout/setUTMPageSize", pageSize);
      this.currentWdwPage = 1;
      this.getWithdrawalList(true);
    },
    changedWdwPage: function(pageNo) {
      this.currentWdwPage = pageNo;
      this.getWithdrawalList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>